import React from 'react';

import OtherInfo from '~/screens/Contract/components/Tabs/OtherInfo/OtherInfo';
import { ContractSubViewHeader } from '../components/ContractSubViewHeader';

type CardOtherInfoViewProps = {
  contractId: string;
  contract: any;
  onBack: () => void;
};

export function CardOtherInfoView({ contractId, contract, onBack }: CardOtherInfoViewProps) {
  return (
    <div>
      <ContractSubViewHeader contractId={contractId} onBack={onBack} />
      <OtherInfo personData={contract?.personData} />
    </div>
  );
}
